import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { MDBInputGroup, MDBCol,MDBBtn,MDBInput } from 'mdb-react-ui-kit';

const Alert = forwardRef((props, ref) => {

    const [value, setValue] = useState(props.item?.amount);

    const add = () => {
        var result = { ...props.item, amount: value };

        props.callback?.apply(this, [result]);

    };


    return (
        <MDBCol md="3">

            <MDBInputGroup textBefore='เพิ่ม' className='mb-3 dropdown-group'>
                <span className='input-group-text text-primary'>{props.item?.text}</span>
                <MDBInput className='form-control' type='number' value={value}
                    onChange={(e) => setValue(e.target.value)} />
                <MDBBtn outline onClick={add}>+</MDBBtn>
            </MDBInputGroup>

        </MDBCol>
    );
});



export default Alert;